import {defineMessages } from "react-intl"

export const generateOptions = (intlService) => {
    const messages = defineMessages({
        "status_new": {
            id: "quote.status_selection.status_new",
            defaultMessage: "New",
        },
        "status_draft": {
            id: "quote.status_selection.status_draft",
            defaultMessage: "Draft",
        },
        "status_proposed": {
            id: "quote.status_selection.status_proposed",
            defaultMessage: "Proposed",
        },
        "status_pre_approved": {
            id: "quote.status_selection.status_pre_approved",
            defaultMessage: "Pre approved",
        },
        "status_approved": {
            id: "quote.status_selection.status_approved",
            defaultMessage: "Approved",
        },
    })
    
    return [
        {
            value: "new",
            label: intlService.formatMessage(messages["status_new"])
        },
        {
            value: "draft",
            label: intlService.formatMessage(messages["status_draft"])
        },
        {
            value: "proposed",
            label: intlService.formatMessage(messages["status_proposed"])
        },
        {
            value: "pre-approved",
            label: intlService.formatMessage(messages["status_pre_approved"])
        },
        {
            value: "approved",
            label: intlService.formatMessage(messages["status_approved"])
        },
    ]
}


// WEBPACK FOOTER //
// ./src/quote/utils/QuoteStatusOrderForm.ts